import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { object, node } from 'prop-types';

class ScrollResetter extends Component {
  static propTypes = {
    location: object,
    children: node,
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollResetter);



// WEBPACK FOOTER //
// ./src/components/ScrollResetter.js